module.exports = __webpack_public_path__ + "static/media/swift.3ba05298.svg";